import { useState, type ReactNode } from "react";
import { Link, useNavigate } from "react-router-dom";

import type { AgentCompany } from "../api/e2e";
import CompanyAutocomplete from "./CompanyAutocomplete";

export default function CompanyContextNavigation({
  companies,
  company,
  backTo,
  backLabel,
  controls,
  actions,
  onBeforeNavigate,
}: {
  companies: readonly AgentCompany[];
  company: AgentCompany;
  backTo: string;
  backLabel: string;
  controls?: ReactNode;
  actions?: ReactNode;
  onBeforeNavigate?: () => boolean;
}) {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  return (
    <div className="model-company-navigation">
      <Link
        to={backTo}
        className="back-link"
        onClick={(event) => {
          if (onBeforeNavigate?.() === false) event.preventDefault();
        }}
      >
        ← {backLabel}
      </Link>
      <div className="model-company-search">
        <CompanyAutocomplete
          companies={companies}
          value={search}
          onChange={setSearch}
          onSelect={(nextCompany) => {
            if (onBeforeNavigate?.() === false) return;
            navigate(`/companies/${encodeURIComponent(nextCompany.id)}`);
          }}
          selectedCompany={company}
        />
      </div>
      {controls && (
        <div className="model-company-navigation__controls">{controls}</div>
      )}
      {actions && (
        <div className="model-company-navigation__actions">{actions}</div>
      )}
    </div>
  );
}
